import { ComponentPropsWithoutRef } from 'react';

export const EuroIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg viewBox="0 0 512 512" {...props}>
      <path
        d="M256 0C114.848 0 0 114.848 0 256s114.848 256 256 256 256-114.848 256-256S397.152 0 256 0m0 480C132.48 480 32 379.52 32 256S132.48 32 256 32s224 100.48 224 224-100.48 224-224 224"
        data-original="#000000"
      />
      <path
        d="M310.976 339.744C299.072 347.872 285.952 352 272 352c-29.472 0-55.008-19.456-68.864-48H256c8.832 0 16-7.168 16-16s-7.168-16-16-16h-62.656c-.736-5.216-1.344-10.528-1.344-16s.608-10.784 1.344-16H272c8.832 0 16-7.168 16-16s-7.168-16-16-16h-68.864c13.856-28.544 39.392-48 68.864-48 13.952 0 27.072 4.128 38.976 12.256 7.296 4.96 17.28 3.136 22.24-4.192 4.992-7.296 3.104-17.248-4.192-22.24C311.936 134.176 292.224 128 272 128c-46.88 0-87.008 33.184-103.68 80H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h17.408c-.576 5.312-1.408 10.528-1.408 16s.832 10.688 1.408 16H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h24.32c16.672 46.816 56.8 80 103.68 80 20.224 0 39.936-6.176 57.024-17.824 7.296-4.992 9.184-14.944 4.192-22.24-4.96-7.296-14.944-9.152-22.24-4.192"
        data-original="#000000"
      />
    </svg>
  );
};
